var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 384,
    viewBox: "0 0 400 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0C35.8173 0 0 35.8173 0 80V304C0 348.182 35.8173 384 80 384H208C252.182 384 288 348.182 288 304V288C288 279.163 280.837 272 272 272C263.163 272 256 279.163 256 288V304C256 330.51 234.51 352 208 352H80C53.4904 352 32 330.51 32 304V80C32 53.4904 53.4904 32 80 32H208C234.51 32 256 53.4904 256 80V96C256 104.837 263.163 112 272 112C280.837 112 288 104.837 288 96V80C288 35.8173 252.182 0 208 0H80Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.686 132.686C318.438 138.934 318.438 149.066 324.686 155.314L345.372 176H159.998C151.163 176 143.998 183.163 143.998 192C143.998 200.837 151.163 208 159.998 208H345.372L324.686 228.686C318.438 234.934 318.438 245.066 324.686 251.314C330.934 257.562 341.065 257.562 347.313 251.314L395.313 203.314C396.859 201.768 398.024 199.984 398.804 198.08C399.526 196.323 399.945 194.41 399.995 192.405C399.998 192.27 400 192.134 400 192C400 191.744 399.993 191.488 399.982 191.232C399.798 187.397 398.243 183.616 395.313 180.686L347.313 132.686C341.065 126.438 330.934 126.438 324.686 132.686Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 384,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b9b29ee4dbea9877942228e9e3b70f2e.svg";
export { ForwardRef as ReactComponent };